import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aebc3b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-menu" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}

import { useStore } from '@/store'
import {
  getMenuChildren,
  normalizeMenuItems,
  pathMapToMenu
} from '@/utils/map-menus'
import { computed, withDefaults } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { editPageData } from '@/service/main/system'
import { getAppTitle } from '@/utils/app-title'
import { getMenuTitle } from '@/utils/menu-title'


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-menu',
  props: {
    collapse: { type: Boolean, default: false }
  },
  setup(__props: any) {

const store = useStore()
const userMenu = computed(() => normalizeMenuItems(store.state.login.userMenu))
const appTitle = computed(() =>
  getAppTitle(store.state.login.userInfo.empNo, '江苏天鼎运营辅助平台')
)
const getDisplayMenuTitle = (title?: string) =>
  getMenuTitle(store.state.login.userInfo.empNo, title || '')



const router = useRouter()
const route = useRoute()

const handleMenuClick = (menu: any) => {
  if (typeof menu?.uri === 'string' && menu.uri.trim()) {
    const path = menu.uri.trim()
    editPageData('/main/topHit/hit', menu)
      .then(() => {
        router.push({
          path
        })
      })
      .catch(() => {
        router.push({
          path
        })
      })
  }
}

const active = computed(() => {
  const menu = pathMapToMenu(userMenu.value, route.path)
  return menu?.id === undefined || menu?.id === null ? '' : String(menu.id)
})

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_submenu = _resolveComponent("el-submenu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "title",
        "enter-active-class": "animate__animated animate__backInLeft",
        "leave-active-class": "animate__animated animate__backOutLeft",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (!_ctx.collapse)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(appTitle.value), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_menu, {
        class: "el-menu-vertical",
        "default-active": active.value,
        "background-color": "#0c2135",
        "text-color": "#b7bdc3",
        collapse: _ctx.collapse,
        "active-text-color": "#0a60bd",
        "unique-opened": true
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userMenu.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_submenu, {
              key: item.id,
              index: item.id,
              onClick: ($event: any) => (handleMenuClick(item))
            }, {
              title: _withCtx(() => [
                (item.icon)
                  ? (_openBlock(), _createElementBlock("em", {
                      key: 0,
                      class: _normalizeClass(item.icon)
                    }, null, 2))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(getDisplayMenuTitle(item.name)), 1)
              ]),
              default: _withCtx(() => [
                (_unref(getMenuChildren)(item).length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(getMenuChildren)(item), (subItem) => {
                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                        key: subItem.id,
                        index: subItem.id,
                        onClick: ($event: any) => (handleMenuClick(subItem))
                      }, {
                        default: _withCtx(() => [
                          (subItem.icon)
                            ? (_openBlock(), _createElementBlock("em", {
                                key: 0,
                                class: _normalizeClass(subItem.icon)
                              }, null, 2))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(subItem.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["index", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["default-active", "collapse"])
    ])
  ]))
}
}

})